import React, { useState } from "react";
import { imageURL } from "constants/urls";

const Investor = ({ investors = [], className = "" }) => {
  const [showAll, setShowAll] = useState(false);
  const maxVisible = 2;

  const visibleInvestors = investors.slice(0, maxVisible);
  const hiddenInvestors = investors.slice(maxVisible);

  const toggleShow = () => setShowAll(!showAll);

  return (
    <div className={`flex items-center flex-wrap w-48 gap-2 ${className}`}>
      {/* Always show first 2 investors */}
      {visibleInvestors.map((inv, idx) => (
        <img
          key={idx}
          src={`${imageURL}/investors/${inv.imageName}`}
          alt={inv.name || `Investor ${idx + 1}`}
          className="rounded-md"
          style={{ maxWidth: 32, maxHeight: 32 }}
        />
      ))}

      {/* Toggle button and hidden investors */}
      {hiddenInvestors.length > 0 && (
        <>
          {!showAll ? (
            <button
              onClick={toggleShow}
              className="text-xs bg-gray-200 rounded-full px-2 py-1 hover:bg-gray-300"
            >
              +{hiddenInvestors.length}
            </button>
          ) : (
            <>
              {hiddenInvestors.map((inv, idx) => (
                <img
                  key={`hidden-${idx}`}
                  src={`${imageURL}/investors/${inv.imageName}`}
                  alt={inv.name || `Investor ${maxVisible + idx + 1}`}
                  className="rounded-md"
                  style={{ maxWidth: 32, maxHeight: 32 }}
                />
              ))}
              <button
                onClick={toggleShow}
                className="text-xs bg-gray-200 rounded-full px-2 py-1 hover:bg-gray-300"
              >
                Hide
              </button>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Investor;